import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import CallIcon from '@material-ui/icons/Call';
import Spinner from '../Spinner';
import swal from 'sweetalert2';
//import FacebookLogin from 'react-facebook-login';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';

// Styles
import styles from './styles';

// Actions
import { attemptLogin } from '../../modules/login';

/**
 *  Primary Contact Dialog Component
 */
class PrimaryContactDialog extends Component {
  state = {};

  handleClose = () => {
    this.props.handleClose();
  };

  _handleCall = () => {
    const { primaryContactNumber } = this.props;
    window.open(`tel:${primaryContactNumber}`);
  };

  render() {
    const {
      fullScreen,
      classes,
      organisationName,
      primaryContactName,
      primaryContactNumber,
      primaryContactEmail
    } = this.props;

    return (
      <Dialog
        fullScreen={fullScreen}
        open={this.props.open}
        key={this.props.open}
        onClose={this.handleClose}
        aria-labelledby="responsive-dialog-title">
        <DialogTitle id="responsive-dialog-title">
          {'Primary Contact Details'}
        </DialogTitle>
        <DialogContent
          classes={{
            root: classes.contentRoot
          }}>
          <DialogContentText>
            The primary contact details for <strong>{organisationName}</strong>
          </DialogContentText>

          {/* Contact Name */}
          <div className={classes.inputRow}>
            <span>Contact Name</span>
            <TextField
              type="text"
              value={primaryContactName}
              label=""
              disabled
              id="bootstrap-input"
              InputProps={{
                disableUnderline: true,
                classes: {
                  root: classes.textFieldRoot,
                  input: classes.textFieldInput
                }
              }}
              InputLabelProps={{
                shrink: true,
                className: classes.textFieldFormLabel
              }}
            />
          </div>

          {/* Contact Email */}
          <div className={classes.inputRow}>
            <span>Contact Email</span>
            <TextField
              type="text"
              value={primaryContactEmail}
              label=""
              disabled
              id="bootstrap-input"
              InputProps={{
                disableUnderline: true,
                classes: {
                  root: classes.textFieldRoot,
                  input: classes.textFieldInput
                }
              }}
              InputLabelProps={{
                shrink: true,
                className: classes.textFieldFormLabel
              }}
            />
          </div>

          {/* Contact Phone Number */}
          <div className={classes.inputRow}>
            <span>Contact Phone Number</span>
            <TextField
              type="text"
              value={primaryContactNumber}
              label=""
              disabled
              id="bootstrap-input"
              InputProps={{
                disableUnderline: true,
                classes: {
                  root: classes.textFieldRoot,
                  input: classes.textFieldInput
                }
              }}
              InputLabelProps={{
                shrink: true,
                className: classes.textFieldFormLabel
              }}
            />
          </div>

          <div style={{ height: 20 }} />

          <Button
            variant="raised"
            color="primary"
            onClick={this._handleCall}
            style={{ alignSelf: 'stretch' }}>
            <CallIcon style={{ marginRight: 10 }} />
            Call Primary Contact
          </Button>
        </DialogContent>

        <DialogActions>
          <Button onClick={this.handleClose} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

PrimaryContactDialog.propTypes = {
  fullScreen: PropTypes.bool.isRequired
};

PrimaryContactDialog = withStyles(styles)(PrimaryContactDialog);
PrimaryContactDialog = withMobileDialog()(PrimaryContactDialog);

function mapStateToProps(state, ownProps) {
  return {
    organisationName: state.app.organisationName,
    primaryContactName: state.app.primaryContactName,
    primaryContactNumber: state.app.primaryContactNumber,
    primaryContactEmail: state.app.primaryContactEmail
  };
}

function mapDispatchToProps(dispatch) {
  return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(
  PrimaryContactDialog
);



// WEBPACK FOOTER //
// ./src/components/PrimaryContactDialog/index.js